import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Button from '@component/form/element/button';
import I18n from '@module/i18n';

import Actions from '@app/store/action';

export function AcceptButton({ onClick, acceptAll, context }) {
  const handleOnClick = () => {
    acceptAll(context);
    onClick && onClick();
  };

  const translatedText =
    context !== 'intro_splash'
      ? 'transfer.consent-manager.button-accept-all'
      : 'transfer.consent-manager.button-accept';

  return (
    <Button
      text={I18n.t(translatedText)}
      className="welcome__button welcome__button--accept"
      onClick={handleOnClick}
    />
  );
}

AcceptButton.propTypes = {
  onClick: PropTypes.func,
  acceptAll: PropTypes.func.isRequired,
  context: PropTypes.string.isRequired,
};

export const mapDispatchToProps = (dispatch) => ({
  acceptAll: (context) => {
    dispatch(Actions.Consent.acceptAll(context));
  },
});

export default connect(null, mapDispatchToProps)(AcceptButton);
